<script setup lang="ts">
withDefaults(
  defineProps<{
    text?: string
    lines?: `five` | `height-to-ten`
  }>(),
  { lines: `height-to-ten` },
);

defineSlots<{
  default: () => unknown
}>();

const textElement = ref<HTMLDivElement>();
const hasOverflow = ref(false);
const showMore = ref(false);
const displayShowMore = computed(() => hasOverflow.value || showMore.value);

useResizeObserver(textElement, (entries) => {
  if (!textElement.value) return;
  const textEntry = entries.find(e => e.target === textElement.value);
  if (!textEntry) return;
  // having borderBoxSize avoid us a getBoundingClientRect() call
  // • support isn't 100% (Safari…)
  //   https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/borderBoxSize
  let height: number;
  const { scrollHeight } = textElement.value;
  if (textEntry.borderBoxSize) {
    // in Chrome & Edge borderBoxSize is an Array
    // in Firefox not…
    const sizes = textEntry.borderBoxSize[0] || textEntry.borderBoxSize;
    // “blockSize” exists in ResizeObserverSize
    // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverSize
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    height = sizes.blockSize;
  }
  else {
    height = textElement.value.offsetHeight;
  }
  // this is how in JS we can check if there is an overflow
  hasOverflow.value = Math.round(height) < Math.round(scrollHeight);
});
</script>

<template>
  <div>
    <div
      ref="textElement"
      class="whitespace-pre-line"
      :class="{
        'line-clamp-[8] lg:line-clamp-[10]': lines === 'height-to-ten' && !showMore,
        'line-clamp-[5]': lines === 'five' && !showMore,
      }"
    >
      <slot />
    </div>
    <IadLinkMoreLess
      v-if="displayShowMore"
      v-model="showMore"
      class="pt-l"
    />
  </div>
</template>
